import { createContext } from 'react';

const BateriaContext = createContext();

export default BateriaContext;